import { getAmenityIcon } from "@/lib/amenities/amenity-icons";
import { cn } from "@/lib/utils";
import { HugeiconsIcon } from "@hugeicons/react";
import Image from "next/image";

export function AmenityIcon({
  slug,
  title,
  className,
}: {
  slug: string;
  title?: string;
  className?: string;
}) {
  const source = getAmenityIcon(slug);
  const iconClassName = cn("size-6 shrink-0 text-foreground", className);

  if (source.type === "hugeicons") {
    return (
      <HugeiconsIcon
        icon={source.icon}
        className={iconClassName}
        strokeWidth={1.5}
      />
    );
  }

  if (source.type === "custom") {
    const Icon = source.Icon;
    return <Icon className={iconClassName} />;
  }

  return (
    <Image
      src={source.src}
      alt={title ?? ""}
      width={24}
      height={24}
      className={iconClassName}
    />
  );
}
